import { render } from "./PaidSuc.vue?vue&type=template&id=c89f6e32&scoped=true"
import script from "./PaidSuc.vue?vue&type=script&lang=js"
export * from "./PaidSuc.vue?vue&type=script&lang=js"

import "./PaidSuc.vue?vue&type=style&index=0&id=c89f6e32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89f6e32"]])

export default __exports__